module.exports = __webpack_public_path__ + "img/labs-desperation-cope.9ef770a9.png";